import {Component} from '@angular/core';

@Component({
    template: '<div></div>',
    standalone: false
})
export class ExternalUrlComponent {

}
